<template>
  <div :class="[`header-6`, className || ``]">
    <view30 :houseFillSvgrepoCom1Props="view30Props.houseFillSvgrepoCom1Props" />
  </div>
</template>

<script>
import View30 from "./View30";
export default {
  name: "Header6",
  components: {
    View30,
  },
  props: ["className", "view30Props"],
};
</script>

<style>
.header-6 {
  align-items: flex-end;
  background-color: var(--white);
  display: flex;
  height: 65px;
  justify-content: flex-end;
  left: calc(50% - 961px);
  min-width: 1920px;
  padding: 5.4px 293px;
  position: absolute;
  top: 0;
}

.header-6.header-6-1,
.header-6.header-6-4,
.header-6.header-6-5 {
  align-self: center;
  left: unset;
  margin-top: 0;
  position: relative;
  top: unset;
}

.header-6.header-6-2 {
  align-self: center;
  left: unset;
  position: relative;
  top: unset;
}

.header-6.header-6-6,
.header-6.header-6-7 {
  left: calc(50% - 960px);
}
</style>
